import React from "react";
import AvailableSlots from "../components/AvailableSlots";
import BookingForm from "../components/BookingForm";
import MyBookings from "../components/MyBookings";
import "../styles/bookings.css";

const BookingsPage: React.FC = () => {
  return (
    <div className="fp-bookings-page">
      <header className="fp-bookings-header">
        <h1>Bookings</h1>
        <p className="muted">Book 1:1 sessions with your trainer</p>
      </header>

      <section className="fp-bookings-section">
        <AvailableSlots />
      </section>

      <section className="fp-bookings-section">
        <BookingForm />
      </section>

      <section className="fp-bookings-section">
        <MyBookings />
      </section>
    </div>
  );
};

export default BookingsPage;
